import styled from 'styled-components';

export const HeaderTextWrap = styled.header<{ hasGap: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.hasGap ? '0.75rem' : '')};
  padding: 3rem 0 4.4rem;
`;
